var _module_exports = "<div class='pr-options-pane-wrapper' ng-class='{active:$ctrl.shouldShowWidgetSidebar()}'>\n\t<div qstrap.tabs tabs='$ctrl.tabs'></div>\n</div>\n";;
var path = '/app/src/client/components/options-pane/options-pane.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;